import { Candidate, CandidateFilters, CandidateStatus, CandidateExperience } from '../types/Candidate';

// Mock candidate data
const mockCandidates: Candidate[] = [];

// Get all candidates
export const getCandidates = (): Candidate[] => {
  return [...mockCandidates];
};

// Get a single candidate by ID
export const getCandidate = (id: number): Candidate | undefined => {
  return mockCandidates.find(candidate => candidate.id === id);
};

// Filter candidates
export const filterCandidates = (filters: CandidateFilters): Candidate[] => {
  return mockCandidates.filter(candidate => {
    // Search filter (name, email, position)
    if (filters.search && !candidate.name.toLowerCase().includes(filters.search.toLowerCase()) &&
      !candidate.email.toLowerCase().includes(filters.search.toLowerCase()) &&
      !candidate.position.toLowerCase().includes(filters.search.toLowerCase()) &&
      !candidate.department.toLowerCase().includes(filters.search.toLowerCase())) {
      return false;
    }

    // Status filter
    if (filters.status.length > 0 && !filters.status.includes(candidate.status)) {
      return false;
    }

    // Experience filter
    if (filters.experience.length > 0 && !filters.experience.includes(candidate.experience)) {
      return false;
    }

    // Department filter
    if (filters.department.length > 0 && !filters.department.includes(candidate.department)) {
      return false;
    }

    // Date range filter
    if (filters.dateRange.start || filters.dateRange.end) {
      const appliedDate = new Date(candidate.appliedDate);

      if (filters.dateRange.start) {
        const startDate = new Date(filters.dateRange.start);
        if (appliedDate < startDate) {
          return false;
        }
      }

      if (filters.dateRange.end) {
        const endDate = new Date(filters.dateRange.end);
        if (appliedDate > endDate) {
          return false;
        }
      }
    }

    return true;
  });
};

// Get available departments from candidates
export const getAvailableDepartments = (): string[] => {
  const departments = mockCandidates.map(c => c.department);
  // return [...new Set(departments)];
  return [...departments];
};

// Add a new candidate
export const addCandidate = (candidate: Omit<Candidate, 'id'>): Candidate => {
  const newId = mockCandidates.length > 0 ? Math.max(...mockCandidates.map(c => c.id)) + 1 : 1;
  const newCandidate = { ...candidate, id: newId };
  mockCandidates.push(newCandidate); // Prepend or append
  return newCandidate;
};